import { CalendarBlank } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PageSEO from "@/components/PageSEO";

export default function Events() {
  return (
    <div>
      <PageSEO
        title="Events – Where the Mayoto Community Gathers"
        description="Mayoto events — investor gatherings, awards nights and partnership showcases. Register your interest and get notified when the next event is confirmed."
        canonicalPath="/events"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">MAYOTO EVENTS</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="events-title">
            Where the Mayoto community gathers.
          </h1>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-wide">
          <div className="mx-auto max-w-2xl text-center bg-[#0a1128] text-white rounded-3xl p-12 lg:p-16">
            <div className="mx-auto h-16 w-16 rounded-2xl bg-[#00b4d8]/15 grid place-items-center">
              <CalendarBlank size={32} weight="bold" className="text-[#00b4d8]" />
            </div>
            <p className="mt-6 text-[#d4af37] font-display font-bold tracking-[0.3em] text-xs">COMING SOON</p>
            <h2 className="mt-3 font-display font-black text-3xl lg:text-4xl leading-tight">
              Our next event is being planned.
            </h2>
            <p className="mt-4 text-slate-300 leading-relaxed">
              We are curating the next Mayoto experience — for investors, partners and friends of the community.
              Details will be published here as soon as the date and venue are confirmed.
            </p>
            <Link to="/contact" className="mt-8 inline-block">
              <Button data-testid="events-notify-cta" className="btn-shine bg-[#00b4d8] hover:bg-[#0096c7] rounded-full px-7 py-6 text-base">
                Notify me when it&rsquo;s live
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
